<<!-- head -->
<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="head">
      <el-tab-pane label="认证流程" name="kol"></el-tab-pane>
      <el-tab-pane label="认证列表" name="kolpross"></el-tab-pane>
    </el-tabs>
    <div v-if="activeName=='kol'">
        <kolpross/>
    </div>
    <div v-if="activeName=='kolpross'">
      <kol/>
    </div>
  </div>
</template>

<script>
import kol from './kol';
import kolpross from './kolpross';
export default {
  name: "heads",
  data() {
    return {
      activeName: "kol"
    };
  },
  components: {
    kol:kol,
    kolpross:kolpross
  },
  created() {
    if(this.$route.query.type==1){
      this.activeName="kol"
    }else{
      this.activeName="kolpross"
    }
  },
  mounted() {},
  methods: {
    handleClick(e) {
      console.log(this.activeName);
    }
  }
};
</script>
<style  scoped>
.head {
  margin-top: 20px;
  font-size:20px;
}
</style>